<div
  class="icon__wrapper icon__wrapper--badge"
  [ngClass]="'icon__wrapper--' + config().variant">
  <span class="icon__name" [ngClass]="'icon__name--' + config().variant">
    {{ config().label }}
  </span>
</div>
